var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "export",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_export",
    "data-name": "vuesax/outline/export"
  }, /*#__PURE__*/React.createElement("g", {
    id: "export-2",
    "data-name": "export"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M.218,9.477a.754.754,0,0,1,0-1.06l8.2-8.2a.75.75,0,0,1,1.06,1.06l-8.2,8.2a.748.748,0,0,1-1.06,0Z",
    transform: "translate(12.252 2.052)",
    fill: "#bf8d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.8,5.55V1.5H.75A.755.755,0,0,1,0,.75.755.755,0,0,1,.75,0h4.8A.755.755,0,0,1,6.3.75v4.8a.75.75,0,0,1-1.5,0Z",
    transform: "translate(16.449 1.25)",
    fill: "#bf8d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M7.75,21.5C2.32,21.5,0,19.18,0,13.75v-6C0,2.32,2.32,0,7.75,0h2a.755.755,0,0,1,.75.75.755.755,0,0,1-.75.75h-2C3.14,1.5,1.5,3.14,1.5,7.75v6C1.5,18.36,3.14,20,7.75,20h6C18.36,20,20,18.36,20,13.75v-2a.75.75,0,0,1,1.5,0v2c0,5.43-2.32,7.75-7.75,7.75Z",
    transform: "translate(1.25 1.25)",
    fill: "#bf8d46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M24,0V24H0V0Z",
    fill: "#bf8d46",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.137d29430a57497219a83be9219ba90a.svg";
export { ForwardRef as ReactComponent };